import { Tag } from '@cian/components';
import * as React from 'react';

import { IComissionTypeTag } from '../../../state/tags/definitions/comission_type';
import { TagNew } from '../TagNew';
import { tagThemeSmall } from '../tag_theme';

export interface IComissionTypeTagItemProps {
  tag: IComissionTypeTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const ComissionTypeTagItem = ({ withNewTag, onDeleteClick, tag }: IComissionTypeTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {(tag.value === 1 && 'Эксклюзивная комиссия') || 'Без комиссии'}
    </TagComponent>
  );
};
